import { faCalendarCheck, faCircleInfo, faUser } from "@fortawesome/free-solid-svg-icons";
import { formatDate, formatInReal } from "../../../../../commons/util/HallAppUtil";

// visits/VisitItem.jsx
import { Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function VisitItem({ visit }) {
  const value = Number(visit.value) || 0;

  return (
    <div className="hc-cd-visit" role="button" tabIndex={0}>
      <div className="hc-cd-visit__left">
        <div className="hc-cd-visit__title">
          <span className="hc-cd-dot" aria-hidden="true" />
          <span className="text-truncate">{visit.serviceName || "Serviço"}</span>
        </div>

        <div className="hc-cd-visit__meta">
          <span className="me-3">
            <FontAwesomeIcon icon={faCalendarCheck} className="me-2" />
            {visit.serviceDate ? formatDate(visit.serviceDate) : "Data não informada"}
          </span>

          {visit.employeeName ? (
            <span className="text-truncate">
              <FontAwesomeIcon icon={faUser} className="me-2" />
              {visit.employeeName}
            </span>
          ) : null}
        </div>

        {visit.notes ? (
          <div className="hc-cd-visit__notes">
            <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
            <span className="text-truncate">{visit.notes}</span>
          </div>
        ) : null}
      </div>

      <div className="hc-cd-visit__right">
        <Badge className="hc-cd-badge" pill>
          {formatInReal(value)}
        </Badge>
      </div>
    </div>
  );
}
